import { useCallback } from 'react';
import { LD_JSON_HEADERS, useApiCall } from './apiHelpers';

export interface CreateCommunicationInputPayload {
  defTitle: string;
  defDescription?: string;
  defChannelId: number;
  defSendStart?: string;
  defNotSendable?: number;
  targetTitle?: string;
  targetDescription?: string;
  targetQueryId?: number;
  targetCategoryId?: number;
  creationPayload?: Record<string, unknown>;
}

export interface CommunicationInputCreated {
  id: number;
  defTitle: string;
  defChannelId: number;
  defSendStart: string | null;
}

const useCreateCommunicationInput = () => {
  const { authFetch, isReady, run, isLoading, error } = useApiCall();

  const createCommunicationInput = useCallback(
    async (payload: CreateCommunicationInputPayload): Promise<CommunicationInputCreated | null> => {
      if (!isReady) return null;
      const outcome = await run<CommunicationInputCreated>(
        () => authFetch('/communication_inputs', { method: 'POST', headers: LD_JSON_HEADERS, body: JSON.stringify(payload) }),
        'Erreur lors de la création de la communication',
      );
      return outcome.ok ? outcome.data : null;
    },
    [authFetch, isReady, run],
  );

  return { createCommunicationInput, isLoading, error };
};

export default useCreateCommunicationInput;
